import {
    ArrayInput,
    BooleanInput,
    Create,
    Edit,
    EditButton,
    List,
    required,
    SimpleForm,
    SimpleFormIterator,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import { ResourceListTitle } from '../AdminResourceTotalCount';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';
import { ContentCatalogMembershipInputs } from '../ContentCatalogMembershipInputs';

const userFilters = [
    <TextInput source="all" label="Rechercher" alwaysOn />
];

export const MedleyList = (props) => {
    const demoMode = Boolean(props.demoMode);

    return (
        <List
            title={
                <ResourceListTitle
                    resource="medley"
                    label={demoMode ? "Medleys — Démo" : "Medleys"}
                    queryString={`is_demo=${demoMode}`}
                />
            }
            {...props}
            filter={{ is_demo: demoMode }}
            filters={userFilters}
            bulkActionButtons={false}
            sort={{ field: 'name', order: 'ASC' }}
            perPage={50}
            pagination={<AdminPagination />}
            exporter={false}
        >
            <AdminSelectableDatagrid>
                <TextField source="name" label="Nom" />
                <EditButton />
                <HumanDeleteButton
                    fields={["name"]}
                    fallback="ce medley"
                />
            </AdminSelectableDatagrid>
        </List>
    );
};

export const MedleyEdit = (props) => (
    <Edit
        {...props}
        mutationMode="pessimistic"
        title={<HumanRecordTitle fields={["name"]} fallback="Fiche" />}
    >
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput source="name" label="Nom" validate={required()} />
            <TextInput source="video_plain" label="Vidéo standard" validate={required()} />
            <TextInput source="video_off" label="Vidéo OFF" validate={required()} />
            <TextInput source="video_off_instructions" label="Instructions vidéo OFF" validate={required()} />
            <BooleanInput source="is_demo" label="Démo" validate={required()} defaultValue={false} />
            <ContentCatalogMembershipInputs
                defaultStandard={!Boolean(props.demoMode)}
            />

            <ArrayInput source="tracks">
                <SimpleFormIterator>
                    <TextInput source="" key={Math.random() + ''} />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Edit>
);

export const MedleyCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect={props.basePath || 'list'}>
            <TextInput source="name" label="Nom" validate={required()} />
            <TextInput source="video_plain" label="Vidéo standard" validate={required()} />
            <TextInput source="video_off" label="Vidéo OFF" validate={required()} />
            <TextInput source="video_off_instructions" label="Instructions vidéo OFF" validate={required()} />

            <BooleanInput
                source="is_demo"
                label="Démo"
                validate={required()}
                defaultValue={Boolean(props.demoMode)}
            />
            <ContentCatalogMembershipInputs
                defaultStandard={!Boolean(props.demoMode)}
            />

<ArrayInput source="tracks">
                <SimpleFormIterator>
                    <TextInput source="" key={Math.random() + ''} />
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);
